module.exports = __webpack_public_path__ + "static/media/hifi.123d2979.png";